import React, {useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useApp} from '../../utilities/contexts/app-context';
import useToast from '../../utilities/customHooks/toast';

const RequireAuth = ({children}) => {
    const {authed, setAuthed} = useApp();
    const {toastError} = useToast();
    const location = useLocation();

    const token = sessionStorage.getItem('session_token');

    useEffect(() => {
        if (!token) {
            toastError("Effettuare l'accesso.");
        } else setAuthed(true);
    }, []);

    if (token) {
        return <>{children}</>;
    } else {

        return (
            <Navigate
                to="/login"
                replace
                state={{from: location.pathname}}
            />
        );
    }
};

export default RequireAuth;
